<template>
  <!--  v-if="!!info" -->
  <div class="footer">
    <div class="footer_cont animate__animated animate__slideInUp">
      <div v-for="(item,index) in footTab" :key="index"
        :class="['footer_cont_item', footTabIndex == index && item.type == 2 ? 'footer_cont_item_active' : '']"
        @click="footTabClick(index,item)">
        <!-- <div class="footer_cont_item_1" v-if="item.type == 2">{{item.name}}</div> -->
        <img :src="footTabIndex == index ? item.img2 : item.img" alt=""
          class="footer_cont_item_2">
      </div>
    </div>
  </div>
</template>
<script>
  /**
   * Created by www.xingnuocn.com
   * @title：公共底部
   * @author: 刘嘉鑫
   */
  export default {
    data() {
      return {
        footTab: [{
          name: "首页",
          img: require('@/assets/img/f_1.png'),
          img2: require('@/assets/img/f_1_1.png'),
          type: 1,
          path: "/"
        }, {
          name: "汰汰清单",
          img: require('@/assets/img/f_2.png'),
          img2: require('@/assets/img/f_2_1.png'),
          type: 3,
          path: "eliminationList"
        }, {
          name: "打单",
          img: require('@/assets/img/f_3.png'),
          img2: require('@/assets/img/f_3_1.png'),
          type: 2,
          path: "orderPrinting"
        }],
        footTabIndex: 0,
      };
    },
    watch: {
      // 利用watch方法检测路由变化：
      $route: function (to, from) {
        console.log("totot", to)
        for (let a in this.footTab) {
          if (to.name == this.footTab[a].path) {
            this.footTabIndex = a
          }
        }
      },
    },
    mounted() {
      for (let a in this.footTab) {
        if (this.$route.name == this.footTab[a].path) {
          this.footTabIndex = a
        }
      }
    },
    methods: {
      footTabClick(index, item) {
        this.footTabIndex = index
        this.$router.push({
          path: item.path,
        });
      }
    },
  };
</script>
<style lang="scss" scoped>
  .footer {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    z-index: 999;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    .footer_cont {
      background: rgba(255, 255, 255, .4);
      border-radius: 44px;
      display: flex;
      align-items: center;
      padding: 8px 16px;

      .footer_cont_item {
        width: 64px;
        height: 64px;
        background: #FFFFFF;
        border: 2px solid #ffffff;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        cursor: pointer;

        .footer_cont_item_1 {
          font-weight: bold;
          font-size: 18px;
          color: #0057FE;
        }

        .footer_cont_item_2 {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .footer_cont_item_active {
        background: #0057FE;
        border-color: #0057FE;

        .footer_cont_item_1 {
          color: #FFFFFF;
        }
      }

      .footer_cont_item:last-child {
        margin: 0 !important;
      }
    }
  }
</style>
